import { pointCountry } from 'components/function';
import { ITransportSection } from 'types/transport'

const First = ({ transportInfo }: ITransportSection) => {
    const tHeader = [
        { label: "운송등록일시", flex: 1 },
        { label: "계정", flex: 1.5 },
        { label: "부킹번호", flex: 1 },
        { label: "화물명", flex: 1 },
        { label: "BL", flex: 1 },
        { label: "HS CODE", flex: 1 },
        { label: "출발지", flex: 1 },
        { label: "도착지", flex: 1 },
        { label: "운송업체", flex: 1.5 },
        { label: "ETD", flex: 1 },
        { label: "ETA", flex: 1 },
    ];

    const tBodyStyle = () => {
        return `flex items-center justify-center py-4.5 text-center`
    }

    return (
        <div className='bg-white border border-[#9D9EB7] rounded-lg'>
            <div className='flex items-center bg-[#F8F8FA] px-10 rounded-t-lg h-15'>
                <p className='font-semibold text-2xl'>운송장 정보</p>
            </div>

            {
                transportInfo &&
                <div className='flex flex-col p-6 select-text'>
                    <div className='border border-[#9D9EB7] rounded overflow-hidden'>
                        <div className='flex bg-[#EEF4FF] font-semibold text-sm'>
                            {
                                tHeader.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                    >
                                        {item.label}
                                    </div>
                                ))
                            }
                        </div>

                        <div className={`flex text-sm`}>
                            <div className={`flex-[1] ${tBodyStyle()}`}>
                                {transportInfo.createAt ?? '-'}
                            </div>
                            <div className={`flex-[1.5] ${tBodyStyle()}`}>
                                {transportInfo.username ?? '-'}
                            </div>
                            <div className={`flex-[1] ${tBodyStyle()}`}>
                                {
                                    transportInfo.transportType === 'SEA' ?
                                        transportInfo.bookingNumber ?? '-' :
                                        transportInfo.mawb ?? '-'
                                }
                            </div>
                            <div className={`flex-[1.0] ${tBodyStyle()}`}>
                                {transportInfo.productNameKr ?? '-'}
                            </div>
                            <div className={`flex-[1] ${tBodyStyle()}`}>
                                {transportInfo.blNo ?? '-'}
                            </div>
                            <div className={`flex-[1] ${tBodyStyle()}`}>
                                {transportInfo.hsCode ?? '-'}
                            </div>
                            <div className={`flex-[1.0] ${tBodyStyle()} flex-col`}>
                                <p dangerouslySetInnerHTML={{ __html: pointCountry(transportInfo.originCode) }}></p>
                                <p>{transportInfo.originAddress}</p>
                            </div>
                            <div className={`flex-[1.0] ${tBodyStyle()} flex-col tran`}>
                                <p dangerouslySetInnerHTML={{ __html: pointCountry(transportInfo.destinationCode) }}></p>
                                <p>{transportInfo.destinationAddress}</p>
                            </div>
                            <div className={`flex-[1.5] ${tBodyStyle()}`}>
                                {transportInfo.carrierName}
                            </div>
                            <div className={`flex-[1] ${tBodyStyle()}`}>
                                {transportInfo.etd ?? '-'}
                            </div>
                            <div className={`flex-[1] ${tBodyStyle()}`}>
                                {transportInfo.eta ?? '-'}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default First